import { action } from "typesafe-actions";
import ActionTypes from "../../constants";

export const onMMVScreenSkipped = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "bike_prequote_screen_skipped",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const onMMVScreenWithAutofillLoaded = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "view_page_prequote_screen",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const onMMVPageLoaded = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "view_page_enter_bike_details",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const viewPlansClicked = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_view_plans",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const tapBtnRegYear = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_reg_year",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const tapBtnPolicyStatus = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_policy_expiry_status",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const onMobileNumberEntered = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "mobile_number_entered",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const onBikeMakeModalClicked = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_bike_make_model",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const onPopularBikeSelected = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "popular_bike_make_model_selected",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const onTypedBikeSelected = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "typed_bike_make_model_selected",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const onTermAndConClicked = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_tnc",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const onChassisNumberUpdated = (chassisNumber: string) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_chassis_number_update_new_bike",
    customAttributes: {
      chassis_number: chassisNumber,
      product_state: "Prequote",
      page: "prequote"
    }
  });

///
